module.exports = __webpack_public_path__ + "static/media/pluto-security-logo-w.4c2a8f67.png";